import { motion } from "framer-motion"
import { TeamMember } from "./TestimonialsPresenter";

interface Props
{
    index: number;
    content: TeamMember;
    isActive: boolean;
    setActive: React.Dispatch<React.SetStateAction<TeamMember>>;
}

const Card: React.FC<Props> = (props) => {
    return (
        <motion.div 
            className={`flex-shrink-0 md:h-[150px] md:w-[150px] h-[125px] w-[125px] rounded-full overflow-hidden ${!props.isActive ? "shadow-[0_5px_10px_rgba(0,0,0,0.5)]" : "shadow-[0_10px_10px_rgba(0,0,0,0.5)]"} hover:shadow-[0_10px_10px_rgba(0,0,0,0.5)] hover:cursor-pointer`}
            whileHover={{opacity: 1, scale: 1.05}}
            style={{scale: props.isActive ? 1.05 : 1, opacity: props.isActive ? 1 : 0.50}}
            transition={{duration: 0.3}}
            onClick={() => props.setActive(props.content)}>
            <img src={props.content.src} alt="avatar" />
        </motion.div>
)}

export default Card;